var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PayWidget',{attrs:{"company":_vm.company,"merchant":_vm.merchant,"invoice":_vm.invoice,"transaction":_vm.transaction,"params":_vm.params},on:{"reload":function($event){return _vm.$emit('reload')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }